import axios from "axios";
const request = axios.create({
  baseURL: process.env.REACT_APP_DOMAIN || window.location.origin, // 所有接口的基础路径
  headers: { "Content-Type": "application/x-yes-2-noenc", },
});

export default request;
